[
  {
    "id": 0,
    "name": { "fr": "Objets de base", "en": "Basic items", "es": "Objetos de base" }
  },
  {
    "id": 1,
    "name": { "fr": "Kit de premiers secours", "en": "First aid kit", "es": "Kit de primeros auxilios" }
  },
  {
    "id": 2,
    "name": { "fr": "Destruction massive", "en": "Massive destruction", "es": "Destrucción masiva" }
  },
  {
    "id": 3,
    "name": { "fr": "Champignons", "en": "Mushrooms", "es": "Setas" }
  },
  {
    "id": 4,
    "name": { "fr": "Cartes à jouer", "en": "Deck of cards", "es": "Baraja de cartas" }
  },
  {
    "id": 5,
    "name": { "fr": "Signes du zodiaque", "en": "Zodiac signs", "es": "Signos del zodíaco" }
  },
  {
    "id": 6,
    "name": { "fr": "Potions du zodiaque", "en": "Zodiac potions", "es": "Pociones del zodíaco" }
  },
  {
    "id": 7,
    "name": { "fr": "Coeur 1", "en": "Heart 1", "es": "Corazón 1" }
  },
  {
    "id": 8,
    "name": { "fr": "Coeur 2", "en": "Heart 2", "es": "Corazón 2" }
  },
  {
    "id": 9,
    "name": { "fr": "Coeur 3", "en": "Heart 3", "es": "Corazón 3" }
  },
  {
    "id": 10,
    "name": { "fr": "Trésor des pirates", "en": "Pirate treasure", "es": "Tesoro de los piratas" }
  },
  {
    "id": 11,
    "name": { "fr": "Gadgets Motion-Twin", "en": "Motion-Twin Gadgets", "es": "Cachibaches Motion-Twin" }
  },
  {
    "id": 12,
    "name": { "fr": "Armement norvégien expérimental", "en": "Norwegian experimental armament", "es": "Armamento noruego experimental" }
  },
  {
    "id": 13,
    "name": { "fr": "Eclairage antique", "en": "Ancient light", "es": "Alumbrado antiguo" }
  },
  {
    "id": 14,
    "name": { "fr": "Igor-Newton", "en": "Igor-Newton", "es": "Igor-Newton" }
  },
  {
    "id": 15,
    "name": { "fr": "Flocon 1", "en": "Snowflake 1", "es": "Copo 1" }
  },
  {
    "id": 16,
    "name": { "fr": "Flocon 2", "en": "Snowflake 2", "es": "Copo 2" }
  },
  {
    "id": 17,
    "name": { "fr": "Flocon 3", "en": "Snowflake 3", "es": "Copo 3" }
  },
  {
    "id": 18,
    "name": { "fr": "Kit d'appel main libre", "en": "Car Kit", "es": "Kit de manos libres" }
  },
  {
    "id": 19,
    "name": { "fr": "Mario party", "en": "Mario Party", "es": "Fiesta Mario" }
  },
  {
    "id": 1000,
    "name": { "fr": "Petites gâteries", "en": "Little treats", "es": "Pequeñas travesuras" }
  },
  {
    "id": 1001,
    "name": { "fr": "Aliments classiques", "en": "Classic food", "es": "Alimentos clásicos" }
  },
  {
    "id": 1002,
    "name": { "fr": "Friandises", "en": "Bobble Cane", "es": "Golosinas" }
  },
  {
    "id": 1003,
    "name": { "fr": "Pierres précieuses", "en": "Precious stones", "es": "Piedras preciosas" }
  },
  {
    "id": 1004,
    "name": { "fr": "Junk food", "en": "Junk food", "es": "Comida basura" }
  },
  {
    "id": 1005,
    "name": { "fr": "Exotic !", "en": "Exotic!", "es": "¡Exotismo!" }
  },
  {
    "id": 1006,
    "name": { "fr": "Apéritifs", "en": "Aperitives", "es": "Aperitivos" }
  },
  {
    "id": 1007,
    "name": { "fr": "Kapital Risk", "en": "Kapital Risk", "es": "Kapital Risk" }
  },
  {
    "id": 1008,
    "name": { "fr": "Trophées de Grand Prédateur", "en": "Great Predator Trophies", "es": "Trofeos del Gran Depredador" }
  },
  {
    "id": 1009,
    "name": { "fr": "Délices de Harry 'le beau'", "en": "Good-looking Harry's delights", "es": "Delicias de Harry 'el guapo'" }
  },
  {
    "id": 1010,
    "name": { "fr": "Chocolats", "en": "Chocolates", "es": "Bombones de chocolate" }
  },
  {
    "id": 1011,
    "name": { "fr": "Fromages", "en": "Cheese", "es": "Quesos" }
  },
  {
    "id": 1012,
    "name": { "fr": "Conserves", "en": "Canned food", "es": "Conservas" }
  },
  {
    "id": 1013,
    "name": { "fr": "Légumes", "en": "Vegetables", "es": "Legumbres" }
  },
  {
    "id": 1014,
    "name": { "fr": "Délices MT", "en": "MotionTwin Delights", "es": "Delicias MotionTwin" }
  },
  {
    "id": 1015,
    "name": { "fr": "Kit de survie MT", "en": "MotionTwin survival kit", "es": "Kit de supervivencia MotionTwin" }
  },
  {
    "id": 1016,
    "name": { "fr": "L'heure du goûter", "en": "Time for tea", "es": "Hora de la merienda" }
  },
  {
    "id": 1017,
    "name": { "fr": "Garçon patissier", "en": "The cake Boy", "es": "El Chico pastelero" }
  },
  {
    "id": 1018,
    "name": { "fr": "Les lois de la robotique", "en": "Laws of Robotics", "es": "Las leyes de la robótica" }
  },
  {
    "id": 1019,
    "name": { "fr": "Trophées de baroudeur", "en": "Fighter's trophies", "es": "Trofeos del peleón" }
  },
  {
    "id": 1020,
    "name": { "fr": "Clés des Glaces", "en": "Ice-cream Keys", "es": "Llaves de Helados" }
  },
  {
    "id": 1021,
    "name": { "fr": "Clé avinée", "en": "Wine Key", "es": "Llave Borracha" }
  },
  {
    "id": 1022,
    "name": { "fr": "Paperasse", "en": "Paperwork", "es": "Papeleo" }
  },
  {
    "id": 1023,
    "name": { "fr": "Clés perdues", "en": "Lost Keys", "es": "Llaves Perdidas" }
  },
  {
    "id": 1024,
    "name": { "fr": "Batons de joie", "en": "Glad sticks", "es": "Bastones de alegría" }
  },
  {
    "id": 1025,
    "name": { "fr": "Boissons rigolotes", "en": "Funny drinks", "es": "Bebidas divertidas" }
  },
  {
    "id": 1026,
    "name": { "fr": "Matériel administratif d'El Papah", "en": "Daddy's administratrive material", "es": "Material administrativo del Papá" }
  },
  {
    "id": 1027,
    "name": { "fr": "Artefacts mythiques", "en": "Mythical artifacts", "es": "Artefactos míticos" }
  },
  {
    "id": 1028,
    "name": { "fr": "Sandy en kit", "en": "Sandy kit", "es": "Sandy en kit" }
  },
  {
    "id": 1029,
    "name": { "fr": "Récompenses du Ninjutsu", "en": "Ninjutsu awards", "es": "Recompensas del Ninjutsu" }
  },
  {
    "id": 1030,
    "name": { "fr": "Artefacts du Ninjutsu", "en": "Ninjutsu artefact", "es": "Artefactos del Ninjutsu" }
  },
  {
    "id": 1031,
    "name": { "fr": "Objets interdits", "en": "Forbidden items", "es": "Objetos prohibidos" }
  }
]
